/**
 * 商品列表接口
 */
export default {
  BASE_URL: '/tm/flow',
  api: [
    {
      name: 'getCompany',
      desc: '获取客户列表',
      method: 'GET',
      path: '/getCompany'
    },
    {
      name: 'getProject',
      desc: '获取项目列表',
      method: 'GET',
      path: '/getProject'
    },
    {
      name: 'list',
      desc: '获取列表',
      method: 'GET',
      path: '/list'
    },
    {
      name: 'export',
      desc: '导出列表',
      method: 'GET',
      path: '/export'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/account/index.js